/* app/js/src/components/common/ag-grid-evrideo/ag-grid-evrideo-checkbox-cell/ag-grid-evrideo-checkbox-cell.component.scss */
:host {
  top: 3px;
  position: relative;
}
/*# sourceMappingURL=ag-grid-evrideo-checkbox-cell.component.css.map */
